import { type App, defineAsyncComponent } from 'vue'

const components = {
  McpConnectCard: defineAsyncComponent(() => import('./McpConnectCard.vue')),
  McpPanel: defineAsyncComponent(() => import('./McpPanel.vue'))
}

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
